import { Box } from "@mui/material";
import { GET_LOCAL_STORAGE } from "Components/Constants/GetLocalStorage";
import { LOCAL_STORAGE } from "Components/Constants/LocalStorage";


const BillHeader = ({ title, date, noDateAndTime }) => {
const header = JSON.parse(localStorage.getItem('bizx_location'))?.stockLocationDetail?.dotHeader;
  return (
    <>
      <div>
        <Box sx={{ marginLeft: 10, marginRight: 10}}>
          <div
            dangerouslySetInnerHTML={{ __html: header }} />
        </Box>



        {/* <div
          style={{
            textAlign: "center",
            fontWeight: 700,
            fontSize: 14,
            textTransform: "uppercase",
          }}
        >
          {title}
        </div> */}

      </div>



      {/* <div>
        {noDateAndTime ? null : (
        <div className="space-between mb" style={{ marginLeft: 10 , marginTop: 40}}>
          <Typography className="header-label">
            <span> Printed Date:&nbsp; {today.toDateString()}</span>
          </Typography>
          <Typography className="header-label"  style={{ marginRight: 20}}>
            <span> Printed Time: &nbsp; {today.toLocaleTimeString()}</span>
          </Typography>
        </div>
      )}
        </div> */}


    </>
  );
};

export default BillHeader;